import type { FaireProductEntity } from "../../entity_types/product";

export const p_9q2dexkux0: FaireProductEntity = {
  token: "p_9q2dexkux0",
  type: "product",
  name: 'Skwishy 4.5" Pet Dogs, Asst, Stretch/Squishy/Squeeze',
  brandToken: "b_83nqde8ah7",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/8521bada5e3a7cdfcf6beea43b4cc3fa080d2ddc3ae636bdcc0a824216dd8519.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa9e31c8e52923b9bbd350fe9bc89d71d20f99dc62d5f0d380b3984bca9b4dd7.jpeg",
    "https://cdn.faire.com/fastly/2eb57fea31432b06f513a001095f01132d858c9286b88e13dc73ec045a388900.jpeg",
    "https://cdn.faire.com/fastly/5eb065978042bb6a2ff4acda7f8f6f8122451ceaa08685e25c36da4c5dd87aa0.jpeg",
    "https://cdn.faire.com/fastly/aa110644a43d5012470db43ceeca86ff50886ee083fa80d0faf64b70d4b92a49.jpeg",
    "https://cdn.faire.com/fastly/e8501e07274006c2ed23a1572b0c9613731c61f85d93451d8ba92220c229b861.jpeg",
    "https://cdn.faire.com/fastly/81dc84ff92b36972cbeea3e5d6ab91a2005959e6cbcc09da10b0144c5acd00c4.jpeg",
    "https://cdn.faire.com/fastly/953f2abd8098d170e8a9a0c332e6f1f09b449cfa73c94c1e2c018d78d22d04ad.jpeg",
  ],
  priceDollars: 5,
  description:
    "Skwishy Pets Dogs measure 4.5 inches in diameter and have rotund spherical bodies. These squish balls come in 4 brightly colored dog styles. Each one has protruding tiny feet, giant black and white eyes, a black nose, and either pointed or folded ears. Choose the brown Pug, beige and pink French Bulldog, orange and white Corgi, or the yellow Labrador Retriever. A Farm Fresh display box holds 12 assorted pups.\r\n\r\n• Age Grade: 3+\r\n• Product Dimensions/Weight: 4.0 L x 4.3 W x 4.0 H / 0.4 lb\r\n• Inner Pack Dimensions/Weight: 13.4 L x 10.7 W x 3.4 H / 5.6 lb\r\n• Made In: China\r\n• Batteries not required",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:36.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
